@if(showModal()) {
	<dialog class="z-999 fixed h-96 w-full left-0 bottom-0 sm:left-6 sm:bottom-6 sm:w-96 p-6 text-peps-dark-200 flex flex-col justify-between shadow-none md:shadow-md" open>
		<div class="flex flex-col gap-10 ">
			<p class="uppercase text-6xl text-wrap w-[90%]">{{ 'component.cookie.omg' | translate }}</p>
			<p class="uppercase text-2xl">{{ 'component.cookie.question' | translate }}</p>
		</div>
		<div class="flex flex-row justify-around items-center">
			<button
				class="text-peps-dark-700 bg-peps-gold py-4 px-8 cursor-pointer hover:bg-peps-yellow transition-colors duration-300 uppercase"
				(click)="acceptCookies()"
			>{{ 'component.cookie.accept' | translate }}</button>
			<button
				class="group cursor-pointer hover:text-peps-orange transition-colors duration-300 pb-2 border-b-2 hover:border-b-peps-brown uppercase text-peps-gold border-b-peps-gold"
				(click)="rejectCookies()"
			>{{ 'component.cookie.reject' | translate }}</button>
		</div>
		<div class="absolute inset-0 size-full z-[-1] bg-peps-dark-900/40"></div>
		<img src="assets/images/cookie_background.avif" alt="" class="absolute inset-0 w-full h-full object-cover object-center z-[-2]">
	</dialog>
}
